import type { ButtonProps } from "@/web/components/primitives/button";
import type { SmbActionCategory } from "@/web/routes/_protected/smb/-dashboard/-types";

export type CategoryPalette = {
  /** solid card background */
  cardBg: string;
  /** default text color on the card background (description, details link) */
  onCardFg: string;
  /**
   * Extra classes layered on top of the `Badge` primitive's `ghost` variant
   * to achieve the category chip look. Empty when the `ghost` default
   * (`bg-card/5 text-withus-white`) already matches.
   */
  badgeClass: string;
  /**
   * `Button` primitive color for the primary CTA. Picked to hit the closest
   * existing compound variant; any remaining mismatch (e.g. category-tinted
   * text on a white button) is covered by `primaryButtonClass`.
   */
  primaryButtonColor: NonNullable<ButtonProps["color"]>;
  primaryButtonClass: string;
  /** Same split for the outline/skip CTA. */
  skipButtonColor: NonNullable<ButtonProps["color"]>;
  skipButtonClass: string;
};

export const CATEGORY_PALETTES: Record<SmbActionCategory, CategoryPalette> = {
  negotiate: {
    cardBg: "bg-withus-red",
    onCardFg: "text-withus-white",
    badgeClass: "",
    primaryButtonColor: "white",
    primaryButtonClass: "text-withus-red",
    skipButtonColor: "white",
    skipButtonClass: "text-withus-white",
  },
  budget: {
    cardBg: "bg-withus-blue",
    onCardFg: "text-withus-white",
    badgeClass: "",
    primaryButtonColor: "white",
    primaryButtonClass: "text-withus-blue",
    skipButtonColor: "white",
    skipButtonClass: "text-withus-white",
  },
  fundraise: {
    cardBg: "bg-withus-yellow",
    onCardFg: "text-withus-blue",
    badgeClass: "bg-withus-blue/5 text-withus-blue",
    primaryButtonColor: "blue",
    primaryButtonClass: "",
    skipButtonColor: "blue",
    skipButtonClass: "",
  },
  generic: {
    cardBg: "bg-withus-dark-blue",
    onCardFg: "text-withus-white",
    badgeClass: "",
    primaryButtonColor: "white",
    primaryButtonClass: "text-withus-dark-blue",
    skipButtonColor: "white",
    skipButtonClass: "text-withus-white",
  },
};
